import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable, combineLatest, filter, map, take } from 'rxjs';
import { AuthService } from '../services/auth.service';

/**
 * Auth Guard
 * Protects routes requiring authentication
 * Redirects unauthenticated users to login page
 * Waits for Firebase auth initialization before checking
 * Based on: agent-os/specs/01-user-authentication-sso/spec.md
 */
@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    // Wait for Firebase auth to finish loading before checking user state
    return combineLatest([
      this.authService.loading$,
      this.authService.currentUser$
    ]).pipe(
      filter(([loading]) => !loading), // Wait until loading is complete
      take(1),
      map(([_, user]) => {
        if (user) {
          return true;
        }

        // Redirect to login page
        return this.router.createUrlTree(['/login']);
      })
    );
  }

  canActivateChild(): Observable<boolean | UrlTree> {
    return this.canActivate();
  }
}
